import { TokenWithValue } from '@/domain/common/types'
import { ObjectiveType } from '@/features/actions/logic/types'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'

import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewSummaryPanel } from '@/features/dialogs/common/components/success-view/SuccessViewSummaryPanel'
import { objectiveTypeToVerb } from '@/features/dialogs/common/logic/title'
import { getDisplayToken } from '@/domain/hooks/useDisplayToken'
import { useChainId } from 'wagmi'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { USD_MOCK_TOKEN } from '@/domain/types/Token'

export interface SuccessViewProps {
  objectiveType: ObjectiveType
  repaymentAsset: TokenWithValue
  onProceed: () => void
  proceedText: string
  isModal?: boolean
  className?: string
}
export function SuccessView({
  objectiveType,
  repaymentAsset,
  onProceed,
  proceedText,
  isModal,
  className,
}: SuccessViewProps) {
  const { token: repaymentToken, value: repaymentValue } = repaymentAsset
  const chainId = useChainId()
  const displayRepaymentToken = getDisplayToken(chainId, repaymentToken)

  const totalRepayUsd = NormalizedUnitNumber(repaymentToken.toUSD(repaymentValue))
  const totalAmount = NormalizedUnitNumber(totalRepayUsd.dividedBy(repaymentToken.unitPriceUsd))

  return (
    <SuccessViewContent className={className}>
      <SuccessViewCheckmark isModal={isModal} />
      <SuccessViewSummaryPanel title={objectiveTypeToVerb[objectiveType]}>
        <div className="flex w-full flex-col gap-2">
          <div className="flex items-center justify-between gap-2 border-border border-b pb-4">
            <div className="flex items-center gap-2">
              <TokenIcon token={repaymentToken} className="h-6" />
              <span className="font-semibold">{displayRepaymentToken.symbol}</span>
            </div>
            <div className="flex grow flex-col">
              <Typography className="text-right font-primary">
                {repaymentToken.format(totalAmount, { style: 'auto' })}
              </Typography>
              <Typography variant="prompt" className="text-right">
                {USD_MOCK_TOKEN.formatUSD(totalRepayUsd)}
              </Typography>
            </div>
          </div>

          {repaymentValue.gt(0) && (
            <div>
              <Typography variant="prompt">Using debt token</Typography>

              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <TokenIcon token={repaymentToken} className="h-6" />
                  <span className="font-semibold">{displayRepaymentToken.symbol}</span>
                </div>
                <div className="flex grow flex-col">
                  <Typography className="text-right font-primary">
                    {repaymentToken.format(repaymentValue, { style: 'auto' })}
                  </Typography>
                  <Typography variant="prompt" className="text-right">
                    {repaymentToken.formatUSD(repaymentValue)}
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </div>
      </SuccessViewSummaryPanel>
      <SuccessViewProceedButton onProceed={onProceed}>{proceedText}</SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
